import ActiveUserPlanColumn from 'modules/profile/user-plan/components/price-plan-columns/components/active-user-plan-column'
import UserPlanColumn from 'modules/profile/user-plan/components/price-plan-columns/components/user-plan-column'
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum'
import { UserPlanTypeEnum } from 'modules/profile/user-plan/enums/user-plan-type-enum'
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface'
import {
  isOneClickAvailable,
  isPlanUpgradeAvailable,
  isUserPlanActive,
} from 'modules/profile/user-plan/utils/price-plan-utils'
import React from 'react'
import { twMerge } from 'tailwind-merge'

export interface PricePlanColumnsProps {
  currentUserPlanData: UseUserPlanInterface
  billingPeriod: BillingPeriodEnum
  showWithTax: boolean
}

const PricePlanColumns = ({
  currentUserPlanData,
  billingPeriod,
  showWithTax,
}: PricePlanColumnsProps) => {
  const calculatedUserPlans =
    currentUserPlanData.userPlan && currentUserPlanData.userPlan.type === UserPlanTypeEnum.promotion
      ? [currentUserPlanData.userPlan, ...currentUserPlanData.userPlans]
      : currentUserPlanData.userPlans
  const isColumnsEnlarged = !!(
    currentUserPlanData.userPlan &&
    currentUserPlanData.userPlan.type === UserPlanTypeEnum.automaticUpgrade
  )

  const isOneClickUpgradeAvailable = isOneClickAvailable(
    currentUserPlanData.customer?.paymentMethod,
  )

  return (
    <div
      className={twMerge(
        'lg:grid',
        isColumnsEnlarged ? 'lg:grid-cols-[repeat(3,1fr)]' : 'lg:grid-cols-[repeat(4,1fr)]',
        'sliderScroll sm:customScroll noScroll flex w-full flex-row items-center gap-6 overflow-y-hidden overflow-x-scroll px-2 pt-10 lg:overflow-hidden lg:px-6',
      )}
    >
      {calculatedUserPlans.map(pricePlan =>
        isUserPlanActive(pricePlan, currentUserPlanData, billingPeriod) ? (
          <ActiveUserPlanColumn
            pricePlan={pricePlan}
            billingPeriod={billingPeriod}
            userRecourses={currentUserPlanData.userResources}
            key={pricePlan.id}
            showWithTax={showWithTax}
          />
        ) : (
          <UserPlanColumn
            pricePlan={pricePlan}
            billingPeriod={billingPeriod}
            key={pricePlan.id}
            isOneClickUpgradeAvailable={isOneClickUpgradeAvailable}
            paymentMethod={currentUserPlanData.customer?.paymentMethod}
            isPlanUpgradeAvailable={isPlanUpgradeAvailable(
              pricePlan,
              billingPeriod,
              currentUserPlanData,
            )}
            showWithTax={showWithTax}
          />
        ),
      )}
    </div>
  )
}

export default PricePlanColumns
